import { UtilsService } from './../../../../utils-service';
import { CommonModule } from '@angular/common';
import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { Subject } from 'rxjs';
import { ColeccionistasService } from '../../coleccionistas.service';

@Component({
    selector: 'documento-identidad-coleccionista',
    templateUrl: 'dpi-coleccionista.component.html',
    imports: [
        CommonModule,
        MatIconModule,
        MatButtonModule
    ],
})

export class DpiColeccionistaComponent implements OnInit {
    @Input() coleccionistaUuid: string;
    @Input() identificacionColeccionista:string
    @ViewChild('fileInput') fileInput: ElementRef<HTMLInputElement>;
    placeholder =  '/assets/images/img-placeholder.jpg' 
    destroy$: Subject<any> = new Subject()

    isDraggingOver = false;
    isToggleChecked: boolean = false;
    isFreeAccount:boolean=false
    image:string
    droppedFiles: File[]=[];
    isSaving:boolean= false

    constructor(
        private coleccionistasService:ColeccionistasService,
        private utilsService: UtilsService
    ) { }

    ngOnInit() { 
        this.image = this.identificacionColeccionista; 
    }

     /*--Funciones para cargar Imagen--*/
    uploadImage() {
        this.fileInput.nativeElement.click();
    }
    
    onDragOver(event: DragEvent) {
        event.preventDefault();
        this.isDraggingOver = true;
    }
    
    onDragLeave(event: DragEvent) {
        event.preventDefault();
        this.isDraggingOver = false;
    }
    
    onDrop(event: DragEvent) {
        event.preventDefault();
        this.isDraggingOver = false;
        if (event.dataTransfer && event.dataTransfer.files.length > 0) {
            const file = event.dataTransfer.files[0];
            this.guardarImagen(file);
            event.dataTransfer.clearData();
        }
    }
    
    private guardarImagen(file: File) {
        const objectUrl = URL.createObjectURL(file);

        const formData = new FormData();
        formData.append('files', file);
        this.coleccionistasService.postIdentificacionColeccionista(this.coleccionistaUuid, formData)
            .then((response: any) => {
                this.image = objectUrl; 
                this.utilsService.openSuccessSnakBar('Imagen cargada exitosamente');
            })
    }
    

    onFileSelected(event: Event) {
        const file = (event.target as HTMLInputElement).files[0];
        if (file) {
            this.guardarImagen(file);
        }
    }


}